import { CardShell } from './CardShell';

export type NotificationItem = {
  id?: string; ID?: string;
  title?: string; Title?: string;
  content?: string; Content?: string;
  created_at?: string; CreatedAt?: string;
  read?: boolean; Read?: boolean;
  biz_ref?: string; BizRef?: string;   // 关联工单号，点击带上下文用
};

const pick = (d: NotificationItem, k: string): string => {
  const v = (d as Record<string, unknown>)[k];
  return typeof v === 'string' ? v : '';
};

export function NotificationCard({
  items, unread_count, source = 'ai', onItemClick,
}: {
  items: NotificationItem[];
  unread_count?: number;
  source?: 'ai' | 'page';
  onItemClick?: (item: NotificationItem) => void;
}) {
  const list = Array.isArray(items) ? items : [];
  return (
    <CardShell title={`通知（未读 ${unread_count ?? list.length}）`} source={source}>
      <div style={{ maxHeight: 260, overflowY: 'auto' }}>
        {list.map((it, i) => {
          const raw = pick(it, 'created_at') || pick(it, 'CreatedAt');
          const t = raw ? new Date(raw) : null;
          const timeText = t && !isNaN(t.getTime())
            ? t.toLocaleString('zh-CN', { hour12: false }) : (raw || '');
          return (
            <div
              key={pick(it, 'id') || pick(it, 'ID') || i}
              onClick={() => onItemClick && onItemClick(it)}
              style={{ padding: '8px 4px', borderBottom: '1px dashed #f0f0f0', cursor: onItemClick ? 'pointer' : 'default', fontSize: 13 }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
                <span style={{ fontWeight: 600 }}>{pick(it, 'title') || pick(it, 'Title') || '(无标题)'}</span>
                <span style={{ color: '#9ca3af', fontSize: 11, whiteSpace: 'nowrap' }}>{timeText}</span>
              </div>
              {pick(it, 'content') || pick(it, 'Content')
                ? <div style={{ color: '#6b7280', fontSize: 12, marginTop: 2 }}>{pick(it, 'content') || pick(it, 'Content')}</div>
                : null}
            </div>
          );
        })}
        {list.length === 0 && <div style={{ color: '#9ca3af', fontSize: 12 }}>暂无通知</div>}
      </div>
    </CardShell>
  );
}
